import { render, staticRenderFns } from "./FornecedorWFDetalheEndereco.vue?vue&type=template&id=7275f9a6&"
import script from "./FornecedorWFDetalheEndereco.vue?vue&type=script&lang=js&"
export * from "./FornecedorWFDetalheEndereco.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports